module.exports = __webpack_public_path__ + "img/PSparabara64_ua.91d99a25.webp";